export const createEmptyCourseForm = () => ({
  courseID: null,
  name: '',
  municipality: '',
  region: '',
});

export const normalizeCourseList = (courses) => {
  if (!Array.isArray(courses)) {
    return [];
  }

  return [...courses]
    .map((course) => ({
      courseID: Number(course?.courseID ?? 0),
      name: String(course?.name ?? '').trim(),
      municipality: String(course?.municipality ?? '').trim(),
      region: String(course?.region ?? '').trim(),
      createdByUserID: course?.createdByUserID == null ? null : Number(course.createdByUserID),
      createdByName: String(course?.createdByName ?? '').trim(),
      createdAt: course?.createdAt ?? null,
      updatedAt: course?.updatedAt ?? null,
      canEdit: Boolean(course?.canEdit),
    }))
    .filter((course) => course.courseID > 0 && course.name)
    .sort((left, right) => {
      const byName = left.name.localeCompare(right.name, 'fi');
      if (byName !== 0) {
        return byName;
      }

      const byMunicipality = left.municipality.localeCompare(right.municipality, 'fi');
      if (byMunicipality !== 0) {
        return byMunicipality;
      }

      return left.region.localeCompare(right.region, 'fi');
    });
};